import { formatDistanceToNow } from 'date-fns';
import { Clock2 } from 'lucide-react';
import { type HTMLAttributes, memo } from 'react';

import { Card } from '@/shared/components/ui/card';

export interface ProfileDetailsGameplayLastPlayedProps extends HTMLAttributes<HTMLDivElement> {
  lastPlayedAt?: string;
}

const getTimeAgoString = (dateString: string): string => {
  const lastPlayed = new Date(dateString);
  return formatDistanceToNow(lastPlayed, { addSuffix: true });
};

export const ProfileDetailsGameplayLastPlayed = memo(
  function ProfileDetailsGameplayLastPlayed(
    props: ProfileDetailsGameplayLastPlayedProps,
  ) {
    const { lastPlayedAt, ...rest } = props;

    const timeAgo = lastPlayedAt
      ? getTimeAgoString(lastPlayedAt)
      : 'long time ago';

    return (
      <Card variant="data" {...rest}>
        <div className="flex items-center gap-1">
          <Clock2 className="bg-cold-400 text-cold-900 size-4 rounded-full [&_circle]:stroke-none" />
          <p className="text-cold-300 text-xs leading-[1]">
            Last played {timeAgo}
          </p>
        </div>
      </Card>
    );
  },
);
